//external
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//internal
import { deleteScheduleType, getScheduleType } from 'services/schedule/type/service';
import history from 'services/history';
import { startRequest, finishRequest } from 'store/modules/loading/actions';
import ContentPanel from 'components/ContentPanel';
import { setMessage } from 'store/modules/message/action';
import { sanitizeErrorUI } from 'utils/errorUtil';
//style
import { Attr, AttrName } from './styled';
import { Button, ButtonContainer } from 'styles/components';

export default function ScheduleTypeDelete({match}) {
  const ScheduleTypeId = match.params.id;
  const message = useSelector(state => state.message.data);
  const [scheduleType, setScheduleType] = useState();

  const dispatch = useDispatch();

  useEffect(() => {
    if (ScheduleTypeId) {
      dispatch(startRequest());
      getScheduleType(ScheduleTypeId).then(data => {
        setScheduleType(data.data);
      }).catch(err => {
        dispatch(setMessage(sanitizeErrorUI(err)));
      }).finally(() => {
        dispatch(finishRequest());
      });
    }
  }, [dispatch, ScheduleTypeId]);

  async function handleDelete () {
    dispatch(startRequest());
    deleteScheduleType(ScheduleTypeId).then(data => {
      history.push('/schedule/schedule_type')
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    }).finally(() => {
      dispatch(finishRequest());
    });
  }

  async function handleBack () {
    history.goBack();
  }

  return (
    <>
      <ContentPanel title="Deseja excluir esta matéria prima?" message={message}>
        {scheduleType && <>
          <AttrName>Descrição:</AttrName>
          <Attr>{scheduleType.description}</Attr>
          <ButtonContainer>
            <br />
            <Button left={true} cancel={true} onClick={handleBack}>
              Voltar
            </Button>
            <Button onClick={handleDelete}>
              Excluir
            </Button>
          </ButtonContainer>
        </>}
      </ContentPanel>
    </>
  )
}